import { type FunctionComponent } from 'react';
import { type FieldError, type FieldErrors } from 'react-hook-form';
import AlertCircleIcon from '../../svgs/untitled-ui/alert-circle.svg';

export type InputMessageProps = {
	invalid?: boolean;
	invalidMessage?: string | FieldError | FieldErrors;
	description?: string;
};

export const InputMessage: FunctionComponent<InputMessageProps> = ({ invalid, invalidMessage, description }) => {
	if (invalid && invalidMessage) {
		return (
			<div
				className={`f7 mt1 theme-error theme-luxury:text-error-primary! flex items-center gc1 theme-luxury:text-sm! theme-luxury:font-light! theme-luxury:mt-1.5!`}
				data-testid="inputMessage">
				<AlertCircleIcon className="f5 minw1" data-testid="AlertCircleIcon" /> <>{invalidMessage}</>
			</div>
		);
	} else if ((!invalid && description) || (invalid && !invalidMessage && description)) {
		return (
			<div
				className={`f7 mt1 theme-grey flex items-center gc1 theme-luxury:text-sm! ${
					invalid ? 'theme-luxury:text-error-primary!' : 'theme-luxury:text-tertiary!'
				} theme-luxury:font-light!  theme-luxury:mt-1.5!`}
				data-testid="inputMessage">
				{invalid && <AlertCircleIcon className="f5 theme-error theme-luxury:text-error-primary!" data-testid="AlertCircleIcon" />}
				{description}
			</div>
		);
	} else {
		return null;
	}
};
